<mobile-page-content [fullPageWidth]="true">

    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <mobile-module-content [title]="pageTitle">
        <div class="mobile-module-content">
            <input-image class="line"
                         [placeholder]="'Avatar'"
                         [allowedExtensions]="usersProvider.AVATAR_ALLOWED_EXTENSIONS"
                         [imageHost]="conf.storageRootUrl"
                         [maxFileSize]="usersProvider.AVATAR_MAX_SIZE"
                         [hint]="'Image_file_hint' | translate:{width: usersProvider.AVATAR_MAX_WIDTH, height: usersProvider.AVATAR_MAX_HEIGHT, size: usersProvider.AVATAR_MAX_SIZE}"
                         (change)="onAvatarImageChange()"
                         [(ngModel)]="avatarImage">
            </input-image>
            <div class="line">
                <mat-radio-group
                        [formControl]="genderFormControl"
                        [required]="true"
                        (keyup)="onGenderChange()"
                        class="flex no-space-between">
                    <mat-radio-button [value]="GENDER_MALE" class="matRadio2Col">
                        {{ 'Man' | translate }}
                    </mat-radio-button>
                    <mat-radio-button [value]="GENDER_FEMALE" class="matRadio2Col">
                        {{ 'Woman' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <mat-form-field class="line">
                <input matInput
                        maxlength="255"
                        placeholder="{{ 'First_name' | translate }}"
                        [formControl]="firstNameFormControl"
                        [required]="true"
                        (keyup)="onFirstNameChange()"
                        [(ngModel)]="user.firstName" />
                <mat-error *ngIf="firstNameFormControl.hasError('required')">{{ 'The_first_name_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                        maxlength="255"
                        placeholder="{{ 'Last_name' | translate }}"
                        [formControl]="lastNameFormControl"
                        [required]="true"
                        (keyup)="onLastNameChange()"
                        [(ngModel)]="user.lastName" />
                <mat-error *ngIf="lastNameFormControl.hasError('required')">{{ 'The_last_name_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line"
                            [hintLabel]="'date_format_hint' | translate">
                <input matInput
                       #birthdayInput
                       [formControl]="birthdayFormControl"
                       [min]="birthdayMinDate"
                       [max]="birthdayMaxDate"
                       [matDatepicker]="picker"
                       [placeholder]="'Birthday' | translate">
                <mat-error *ngIf="birthdayFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="birthdayFormControl.hasError('matDatepickerMin')">{{ 'Error_min_date_x' | translate:{minDate: (utils.DateToYmdHis(birthdayMinDate) | dateClosest:'FjY')} }}</mat-error>
                <mat-error *ngIf="birthdayFormControl.hasError('matDatepickerMax')">{{ 'Error_max_date_x' | translate:{maxDate: (utils.DateToYmdHis(birthdayMaxDate) | dateClosest:'FjY')} }}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                </mat-datepicker>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                        maxlength="255"
                        placeholder="{{ 'Email_address' | translate }}"
                        [formControl]="emailFormControl"
                        [required]="true"
                        (keyup)="onEmailChange()"
                        [(ngModel)]="user.email" />
                <mat-error *ngIf="emailFormControl.hasError('email')">{{ 'Email_invalid' | translate }}</mat-error>
                <mat-error *ngIf="emailFormControl.hasError('unavailable')">{{ 'Email_unavailable' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                        maxlength="255"
                        placeholder="{{ 'Billing_email_address' | translate }}"
                        [formControl]="billingEmailFormControl"
                        (keyup)="onBillingEmailChange()"
                        [(ngModel)]="athleteRow.athlete.billingEmail" />
                <mat-error *ngIf="billingEmailFormControl.hasError('email')">{{ 'Email_invalid' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <mat-select placeholder="{{ 'Lang' | translate }}"
                            (change)="onLangChange()"
                            [(ngModel)]="user.langId">
                    <mat-option *ngFor="let lang of langs" [value]="lang.id">
                        {{ lang.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #postcodeInput
                       [formControl]="postcodeFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Postal_Code' | translate">
                <mat-error *ngIf="postcodeFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
                <mat-error *ngIf="postcodeFormControl.hasError('pattern')">{{ 'Postcode_invalid' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #cityInput
                       [formControl]="cityFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'City' | translate">
                <mat-error *ngIf="cityFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #streetNameInput
                       [formControl]="streetNameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Street_Name' | translate">
                <mat-error *ngIf="streetNameFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #buildingNumberInput
                       [formControl]="buildingNumberFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Building_Number' | translate">
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #addressAdditionInput
                       [formControl]="addressAdditionFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Address_Addition' | translate">
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #phoneNumberInput
                       [formControl]="phoneNumberFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Phone_Number' | translate">
            </mat-form-field>

            <div class="line">
                <button mat-raised-button
                        color="default"
                        (click)="onChangePasswordClicked()">
                    {{ 'Change_password' | translate }}
                </button>
            </div>

            <mat-form-field class="line">
                <mat-label>{{ 'athlete_size' | translate }}</mat-label>
                <input matInput
                       #sizeAthlete
                       [formControl]="sizeFormControl"
                       type="number"
                       autocomplete="off" />
                <span matSuffix>{{ 'cm' | translate }}</span>
            </mat-form-field>
            <mat-form-field class="line">
                <mat-label>{{ 'athlete_weight' | translate }}</mat-label>
                <input matInput
                       #weightAthlete
                       [formControl]="weightFormControl"
                       type="number"
                       autocomplete="off" />
                <span matSuffix>{{ 'Kg' | translate }}</span>
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #sportPracticedInput
                       [formControl]="sportsPracticedFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Sport_Practiced' | translate">
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #clubInput
                       [formControl]="clubFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Club_Name' | translate">
            </mat-form-field>
            <mat-form-field class="line">
                <input matInput
                       #clubInput
                       [formControl]="externalCoachNameFormControl"
                       type="text"
                       maxlength="{{ NAME_MAX_LENGTH }}"
                       [placeholder]="'Athlete_Trainer' | translate">
            </mat-form-field>
            <mat-form-field class="line">
                <mat-select [(ngModel)]="contractTypeSelected"
                            placeholder="{{ 'Contract_Type' | translate }}"
                            [formControl]="contractTypeFormControl">
                    <mat-option *ngFor="let contractType of availableContractTypes" [value]="contractType.id">
                        {{ contractType.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="line">
                <textarea matInput
                          [formControl]="athleteDescriptionFormControl"
                          class="text-area-unresizable"
                          maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                          #athleteDescriptionInput
                          cdkTextareaAutosize
                          placeholder="{{ 'Athlete_Description' | translate }}"></textarea>
                <mat-hint align="end">{{ athleteDescriptionInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
            </mat-form-field>

            <main-action [title]="'Save'"
                         [icon]="'check'"
                         [color]="'accent'"
                         [isLoading]="isLoading"
                         (click)="onSaveClicked()"
            >
            </main-action>
        </div>

    </mobile-module-content>
</mobile-page-content>
